export default {
  fillFlow({ commit }, flow) {
    let formattedFlow = {}
    formattedFlow.name = flow.name
    formattedFlow.active = flow?.active,
    formattedFlow.isDefault = flow?.is_default,
    formattedFlow.canMirror = flow?.can_inactivate,
    formattedFlow.canInactivate = flow?.can_mirror,

    formattedFlow.useTermAcceptance = flow.use_terms_acceptance
    formattedFlow.useDocumentAttachment = flow.use_documents_attachment
    formattedFlow.useSelfieCapture = flow.use_selfie_capture
    formattedFlow.validateBiometry = flow.validate_biometry
    formattedFlow.validateLiveness = flow.validate_liveness
    formattedFlow.useManualAnalysis = flow.use_manual_analysis
    formattedFlow.showCapturedDocumentPreview = Boolean(flow.show_captured_document_preview)
    formattedFlow.showAttachedDocumentPreview = Boolean(flow.show_attached_document_preview)
    formattedFlow.useBiometryRefusal = flow.allow_refusal ?? false
    formattedFlow.useDataCorrectionRequest = flow.allow_correction_request ?? false

    formattedFlow.acceptedDocumentTypes = flow.accepted_document_types
    formattedFlow.acceptPhysicalAsDigital = flow.accept_physical_as_digital
    formattedFlow.acceptedDigitalDocumentTypes = flow.accepted_digital_document_types
    formattedFlow.version = flow.version

    formattedFlow.saleFlows = flow.sale_flows

    commit("updateFlow", formattedFlow)
  },
}
